import HTTP from "@/core/zwzsw_api/config/index.js";
//const URL3 = 'http://192.168.1.21:8081/apis';
const URL3 = "https://wxtest.cnknowledge.com/api";
const URL4 = "https://zwi.cnknowledge.com/api";
const URL5 = "https://zwiii.cnknowledge.com/api";
let getAuthorUrl = () => {
  let url = "";
  if (
    location.host.indexOf("cbtest.") != -1 ||
    location.host.indexOf(":80") != -1 ||
    location.host.indexOf("localhost") != -1
  ) {
    url = URL3; // 投审稿作者端测试环境
  } else if (location.host.indexOf("yucard") != -1) {
    url = URL5; // 投审稿作者端预生产环境
  } else {
    url = URL4; // 投审稿作者端正式环境
  }
  // return url;
  return url;
};
const BASE_URL = getAuthorUrl();
export default {
  login(params) {
    // console.log(data);
    return HTTP.json(BASE_URL + "/zw-user/login", params, false);
  },
  getPk() {
    // console.log(apiList)
    return HTTP.get(BASE_URL + "/zw-user/getPk", false);
  },
  regiteList(params) {
    return HTTP.get(BASE_URL + "/zw-public/sms/sendNew", params, false);
  },

  // 注册
  userList(params) {
    return HTTP.json(BASE_URL + "/zw-user/register/user", params, false);
  },
  //登录
  loginList(params) {
    return HTTP.json(BASE_URL + "/zw-user/login", params, false);
  },
};

// //忘记密码
// export function repwd(data) {
//     return zwitCore.HTTP.json(
//       BASE_URL + "/zw-user/reset/nf/userRetrievePwd",
//       data,
//       false
//     );
//   }
//   //子账号登录 中文知识网的
//   export function sonLogin(data) {
//     return zwitCore.HTTP.json(
//       BASE_URL + "/zw-user/subUser/nf/login",
//       data,
//       false
//     );
//   }
//   //登录注册
//   export function login(data) {
//     return zwitCore.HTTP.json(BASE_URL + "/zw-user/login", data, false);
//   }
//   export function reg(data) {
//     return zwitCore.HTTP.json(BASE_URL + "/zw-user/register/user", data, false);
//   }

//   export function logOut() {
//     return zwitCore.HTTP.json(BASE_URL + "/zw-user/logout");
//   }
